module.exports = __webpack_public_path__ + "img/SD-fig5.917f2e10.png";